import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListObjetives = () => {
    return axios.get(`/api/SkKpi/objetive/list`, { headers: authHeaderJson() } )
};

export {
    getListObjetives
}